import React, { JSX } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import { defaultModalStyle, MediumModalStyle } from "../../constants.ts";
import { ElementSize } from "../../types";

interface ModalComponentProps {
  title: string;
  children: string | JSX.Element;
  isOpen: boolean;
  size?: ElementSize;
  onClose?: () => void;
}

const ModalComponent = ({
  title,
  children,
  isOpen,
  size = "small",
  onClose,
}: ModalComponentProps) => {
  const modalSize =
    size === "small"
      ? defaultModalStyle
      : size === "medium"
        ? MediumModalStyle
        : {};

  return (
    <Modal open={isOpen} onClose={onClose} aria-labelledby="modal-modal-title">
      <Box sx={{ ...modalSize, position: "relative" }}>
        {onClose && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              fontSize: "28px",
              lineHeight: "12px",
              padding: "6px 8px 10px 8px",
            }}
          >
            &times;
          </IconButton>
        )}
        <Typography id="modal-modal-title" variant="h4" component="h2">
          {title}
        </Typography>
        <Box sx={{ mt: 2 }}>{children}</Box>
      </Box>
    </Modal>
  );
};

export default ModalComponent;
